import IdentityValidationBanner from './IdentityValidationBanner';
import IdentityValidationErrorDialog from './IdentityValidationErrorDialog';
import IdentityValidationResultDialog from './IdentityValidationResultDialog';
import ManualValidationDialog from './ManualValidationDialog';
import SelfieVerificationDialog from './SelfieVerificationDialog';

export default function IdentityValidationFlow({
  state,
  flow,
  onApprovedRoute,
}) {
  const handleStartRoute = () => {
    const routeId = flow.approveRoute();
    onApprovedRoute?.(routeId);
  };

  if (!state?.enabled) return null;

  return (
    <>
      {flow.isBlocked && (
        <IdentityValidationBanner
          status={flow.status}
          onValidate={() => flow.openValidationFlow()}
        />
      )}
      <SelfieVerificationDialog
        open={flow.dialog === 'selfie'}
        onClose={flow.closeValidation}
        onSave={flow.submitSelfie}
        isSaving={flow.isSubmitting}
      />
      <ManualValidationDialog
        open={flow.dialog === 'manual'}
        onClose={flow.closeValidation}
        onSave={flow.submitManual}
        isSaving={flow.isSubmitting}
      />
      <IdentityValidationErrorDialog
        open={flow.dialog === 'error'}
        outcome={flow.outcome}
        onRetry={() => {
          flow.closeDialog();
          flow.retrySelfie();
        }}
        onManual={() => {
          flow.closeDialog();
          flow.openManual();
        }}
        onClose={flow.closeDialog}
      />
      <IdentityValidationResultDialog
        open={flow.dialog === 'pending'}
        pending
        onClose={flow.closeValidation}
      />
      <IdentityValidationResultDialog
        open={flow.dialog === 'approved'}
        onStartRoute={handleStartRoute}
      />
    </>
  );
}
